import React, { PureComponent } from 'react';
import injectSheet, {withTheme} from 'react-jss'

import Section from "../Widgets/Section"
import SectionTitle from "../Widgets/SectionTitle"
import CardGrid from '../Card/CardGrid'
import flow from 'lodash/flow'
import BackgroundContrastContainer from './BackgroundContrastContainer'

class ArticlesRow extends PureComponent {
    render() {
        const { classes, theme, slice, color } = this.props;
        const {
          results, summary, landing_page_uid, title,
          link, number_of_articles_per_row, background_contrast,
          show_article_summaries, carousel_on_mobile
         } = slice;
        const isLookbooks = landing_page_uid === 'lookbooks';

        if(!results || results.length === 0) return null;

        return (
          <BackgroundContrastContainer applyContrast={background_contrast === 'Yes'}>
            <SectionTitle text={title} summary={summary} color={theme.colors[landing_page_uid]} link={link} />
            <Section key='content' className={classes.sectionWrapper} dataCy='articlesRowContent'>
                <CardGrid
                  key={results}
                  items={results}
                  columns={isLookbooks ? 4 : number_of_articles_per_row}
                  singleLine={false}
                  showSummary={show_article_summaries === 'Yes'}
                  color={color}
                  carousel={carousel_on_mobile === 'Yes'}
                />
            </Section>
          </BackgroundContrastContainer>
        ) 
    }
}

export default flow( [
    withTheme,
    injectSheet((theme) => ({
      sectionWrapper: {
        marginBottom: 0
      },
      sectionTitle: {
        marginBottom: theme.ds.spacing(4),
        [theme.breakpoint('tablet')]: {
          marginBottom: theme.ds.spacing(6)
        }
      }
    }))
])( ArticlesRow );



// WEBPACK FOOTER //
// ./src/components/LandingPage/ArticlesRow.js